import { CircolareProjection } from './CircolareProjection'
import { PagedBaseState } from './PagedBaseState'

export class CircolariState extends PagedBaseState<CircolareProjection> {

}